/**
 * Shared label registry for `async-select` filters. Maps `filterId + value`
 * to the human label resolved server-side, so the active-filter chips
 * (`DataTableActiveFilters`) can display names — never raw UUIDs — even
 * though the resolved options live inside the filter combobox.
 *
 * Implemented as a tiny external store (compatible with
 * `useSyncExternalStore`) because the filter item and the chips row are
 * sibling components without a shared React state owner.
 */

const labels = new Map<string, string>();
const listeners = new Set<() => void>();
let version = 0;

function keyOf(filterId: string, value: string): string {
  return `${filterId}\u0000${value}`;
}

export function setFilterOptionLabel(filterId: string, value: string, label: string): void {
  const key = keyOf(filterId, value);
  if (labels.get(key) === label) return;
  labels.set(key, label);
  version += 1;
  listeners.forEach((listener) => listener());
}

export function getFilterOptionLabel(filterId: string, value: string): string | undefined {
  return labels.get(keyOf(filterId, value));
}

export function subscribeFilterOptionLabels(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function getFilterOptionLabelsVersion(): number {
  return version;
}
